import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { patient_cornea_data_model } from 'src/simulationAdaptation2/services/getPatientDetail/model'

export interface ProductType {
  id: number
  type_no: string
  type_name: string
  sort: number
  is_show: string
}

const getStorageData = (key: string) => {
  const corneal_topographic = window.localStorage.getItem('corneal_topographic')
  if (corneal_topographic) {
    const corneal = JSON.parse(corneal_topographic)
    return corneal[key]
  } else {
    return null
  }
}

const setStorageData = (key: string, data: PayloadAction) => {
  const corneal_topographic = window.localStorage.getItem('corneal_topographic')
  if (corneal_topographic) {
    const cornealObj = JSON.parse(corneal_topographic)
    window.localStorage.setItem('corneal_topographic', JSON.stringify({ ...cornealObj, [key]: data }))
  } else {
    window.localStorage.setItem('corneal_topographic', JSON.stringify({ [key]: data }))
  }
}

const cornealSlice = createSlice({
  name: 'corneal',
  initialState: {
    leftCorneal: getStorageData('leftCorneal') as patient_cornea_data_model | null,
    rightCorneal: getStorageData('rightCorneal') as patient_cornea_data_model | null,
    productType: getStorageData('productType') as ProductType | null,
    angleSectionLine: 0,
  },
  reducers: {
    setPatient: (state, action) => {
      return { ...state, patient: action.payload }
    },
    setSelectedLeftCorneal: (state, action) => {
      setStorageData('leftCorneal', action.payload)
      return { ...state, leftCorneal: action.payload }
    },
    setSelectedRightCorneal: (state, action) => {
      setStorageData('rightCorneal', action.payload)
      return { ...state, rightCorneal: action.payload }
    },
    setProductType: (state, action) => {
      setStorageData('productType', action.payload)
      return { ...state, productType: action.payload }
    },
    resetCorneal: (state) => {
      window.localStorage.removeItem('corneal_topographic')
      return { ...state, leftCorneal: null, rightCorneal: null, productType: null, errors: {} }
    },
    setAngleSectionLine: (state, action) => {
      return { ...state, angleSectionLine: action.payload }
    },
  },
})

export const { setPatient, setSelectedLeftCorneal, setSelectedRightCorneal, setProductType, resetCorneal, setAngleSectionLine } = cornealSlice.actions

export default cornealSlice
